<template>
  <div class="group-header"
       :class="{'is-active': IDE.layout.showNav}">
    <div @click="$emit('toggle-nav')"
         class="button is-link toggle-nav">
      <v-color-icon name="arrow-left-fill" title="目录" :rotate="IDE.layout.showNav ? 0 : 180"></v-color-icon>
    </div>

    <div>
      <p class="heading">{{ course.name }}：第 {{ group.index }} 章</p>
      <v-transition name="slide-down" :hash="'header.group.name.' + group.name">
        <div><b>{{ group.name }}</b></div>
      </v-transition>
    </div>
    <div class="group-progress is-hidden-mobile">
      <group-progress></group-progress>
    </div>
    <div class="buttons-right flex-pull-right">
      <a target="_blank"
         :href="'https://python123.io/student/courses/' + IClassroom.course._id + '/intro'"
         class="button is-link is-rounded">
        <v-color-icon name="login"></v-color-icon>
        <b>课程主页</b>
      </a>
    </div>
  </div>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'
import GroupProgress from '@/components/classroom/web/partial/GroupProgress'

const IDE = window['IDE']

export default {
  components: { GroupProgress },
  props: ['course', 'group'],
  data () {
    return {
      IDE,
      IClassroom
    }
  }
}
</script>
<style lang="stylus" scoped>
.group-header {
  height: 100%;
  display flex
  align-items center
  color white
  user-select none
  padding 0 3.5rem
  transition all .3s

  &.is-active {
    padding 0 3.5rem 0 2.5rem
  }

  &.is-active .toggle-nav {
    left -15px
  }
}

.group-progress {
  flex-grow 1
  padding 0 1.5rem
}

.toggle-nav {
  height 40px
  width 40px
  cursor pointer
  position absolute
  left 5px
  display flex
  justify-content center
  align-items center
  border-radius 50%
  padding 0
  z-index 2
  transition all .3s
  font-size 22px

  .icon {
    transition all .3s linear .6s
  }
}

.heading {
  display: block;
  font-size: 12px;
  letter-spacing: 1px;
  margin-bottom -2px
}
</style>
